// Common country codes with Australia at the top
export const countryCodes = [
  { code: '+61', country: '(AU)' },
  { code: '+1', country: '(US/CA)' },
  { code: '+44', country: '(UK)' },
  { code: '+64', country: '(NZ)' },
  { code: '+86', country: '(CN)' },
  { code: '+91', country: '(IN)' },
  { code: '+49', country: '(DE)' },
  { code: '+33', country: '(FR)' },
  { code: '+81', country: '(JP)' },
  { code: '+82', country: '(KR)' },
  { code: '+65', country: '(SG)' },
  { code: '+60', country: '(MY)' },
  { code: '+62', country: '(ID)' },
  { code: '+66', country: '(TH)' },
  { code: '+84', country: '(VN)' },
];

// Email validation regex
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
